module.exports = __webpack_public_path__ + "d431028caac017a8df274cd1e2019433.svg";